import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-page__hero">
        <div className="container">
          <div className="legal-page__breadcrumb">
            <Link to="/">Home</Link>
            <span aria-hidden="true">›</span>
            <span>Terms</span>
          </div>
          <h1 className="legal-page__title">Terms of Use</h1>
          <p className="legal-page__meta">
            TaxiOps — An Old Alex Hub Company
            <span aria-hidden="true"> · </span>
            Effective: Phase One Launch, 2025
          </p>
        </div>
      </div>

      <div className="container legal-page__body">
        <div className="legal-page__content">

          <section className="legal-section">
            <h2>About This Document</h2>
            <p>
              These Terms of Use govern your access to and use of this public marketing
              website for TaxiOps (the "Site"), operated by Old Alex Hub. TaxiOps is an
              official business venture of Old Alex Hub. By accessing this Site, you agree
              to these terms.
            </p>
            <p>
              These terms apply to the public marketing website only. They do not govern
              the TaxiOps software platform, which operates under separate agreements
              between Old Alex Hub and its authorized client organizations.
            </p>
          </section>

          <section className="legal-section">
            <h2>Nature of This Site</h2>
            <p>
              This Site is a static public marketing website providing informational
              content about TaxiOps and Old Alex Hub. It does not offer a software
              service, does not provide platform access, and does not facilitate commercial
              transactions or client enrollments through the website.
            </p>
            <p>
              TaxiOps is currently in a focused implementation period. Open self-service
              enrollments are not accepted through this Site, and all availability
              discussions are handled directly by Old Alex Hub.
            </p>
          </section>

          <section className="legal-section">
            <h2>Intellectual Property</h2>
            <p>
              All content on this Site — including but not limited to text, design,
              graphics, the TaxiOps name, the TaxiOps logo, and the Old Alex Hub name —
              is the property of Old Alex Hub and is protected by applicable intellectual
              property law.
            </p>
            <p>
              You may not reproduce, copy, republish, distribute, or create derivative
              works from any content on this Site without the express written permission
              of Old Alex Hub.
            </p>
          </section>

          <section className="legal-section">
            <h2>Accuracy of Information</h2>
            <p>
              Old Alex Hub makes reasonable efforts to ensure the accuracy of information
              on this Site. However, product capabilities, availability status, and
              operational details may change as the TaxiOps platform evolves. Information
              on this Site describes the platform at the time of publication and should not
              be relied upon as a contractual commitment.
            </p>
            <p>
              The TaxiOps platform capabilities described on this Site reflect the
              implemented platform as of Phase One. Future capabilities and features
              are subject to development roadmap decisions and may change.
            </p>
          </section>

          <section className="legal-section">
            <h2>No Warranties</h2>
            <p>
              This Site is provided on an "as is" and "as available" basis without any
              warranty, express or implied. Old Alex Hub makes no representations about
              the suitability, reliability, availability, timeliness, or accuracy of the
              information on this Site for any purpose.
            </p>
          </section>

          <section className="legal-section">
            <h2>Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by applicable law, Old Alex Hub shall not
              be liable for any direct, indirect, incidental, special, or consequential
              damages arising from your use of or inability to use this Site, or from any
              information provided through this Site.
            </p>
          </section>

          <section className="legal-section">
            <h2>External Links</h2>
            <p>
              This Site may contain mailto links that open your email application. These
              links are provided for communication convenience only. Old Alex Hub is not
              responsible for the privacy practices or behavior of your email provider or
              email application.
            </p>
          </section>

          <section className="legal-section">
            <h2>Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with the laws
              of the State of Colorado, United States, without regard to conflict of law
              principles.
            </p>
          </section>

          <section className="legal-section">
            <h2>Changes to These Terms</h2>
            <p>
              Old Alex Hub reserves the right to modify these Terms of Use at any time.
              Changes will be reflected on this page with an updated effective date.
              Continued use of the Site after changes are posted constitutes acceptance
              of the updated terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact</h2>
            <p>
              Questions about these Terms of Use may be directed to Old Alex Hub at:{' '}
              <a href="mailto:info@oldalexhub.com?subject=TaxiOps Terms of Use Inquiry" className="legal-page__link">
                info@oldalexhub.com
              </a>
            </p>
          </section>

          <div className="legal-page__nav-links">
            <Link to="/" className="btn btn--outline">← Back to Home</Link>
            <Link to="/privacy" className="btn btn--outline">View Privacy Policy →</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
